import { OrphanedDonor } from "../../../api/OrderRequests/OrderRequestsModel/Donor"

function DonorIdsCell(donor: OrphanedDonor) {
  const { SSN, EmployerID, DriverID, AlternateID } = donor

  return (
    <td>
      {SSN && SSN.length > 0 && (
        <div>
          <b className="text-secondary fw-600">SSN:</b> {SSN}
        </div>
      )}
      {EmployerID && EmployerID.length > 0 && (
        <div>
          <b className="text-secondary fw-600">EmployerID:</b> {EmployerID}
        </div>
      )}
      {DriverID && DriverID.length > 0 && (
        <div>
          <b className="text-secondary fw-600">DriverID:</b> {DriverID}
        </div>
      )}
      {AlternateID && AlternateID.length > 0 && (
        <div>
          <b className="text-secondary fw-600">AlternateID:</b> {AlternateID}
        </div>
      )}
    </td>
  )
}

export default DonorIdsCell
